import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import { useNotify, useRecordContext, useUpdate } from 'react-admin'
import { sendLog } from '../../../Class/AuditLog'

const ARCHIVE_REASONS = [
  'Car sold elsewhere',
  'Customer requested no further contact',
  'Duplicate lead',
]

const ArchiveLeadButton = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const [update, { isLoading, error }] = useUpdate()
  const [isArchived, setIsArchived] = useState(false)
  const [buttonText, setButtonText] = useState('Archive')
  const [modalOpen, setModalOpen] = useState(false)
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (record) {
      setIsArchived(record.archived)
      setButtonText(record.archived ? 'UnArchive' : 'Archive')
    }
  })

  const closeModal = () => {
    setModalOpen(false)
    setReason('')
  }

  const setArchived = (archived, archiveReason, logDescription) => {
    if (!record) return

    update(
      'quote-requests',
      {
        id: record.id,
        data: { archived, archiveReason },
        previousData: record,
      },
      {
        onSuccess: () => {
          sendLog(record.originId, logDescription)
          closeModal()
        },
        onError: (updateError) =>
          notify('Error updating lead: ' + updateError.message, {
            type: 'error',
          }),
      }
    )
  }

  const handleClick = () => {
    if (isArchived) {
      // Clear the reason so a re-archive can't inherit the previous one
      setArchived(false, null, 'Lead Unarchived')
    } else {
      setModalOpen(true)
    }
  }

  if (error) {
    return (
      <Button fullWidth disabled={true} color="error">
        ERROR
      </Button>
    )
  }

  return (
    <React.Fragment>
      <Button
        fullWidth
        onClick={handleClick}
        disabled={isLoading}
        variant={isArchived ? 'contained' : 'outlined'}
        color={isArchived ? 'warning' : 'primary'}
      >
        {buttonText}
      </Button>

      <Dialog open={modalOpen} onClose={closeModal} maxWidth="xs" fullWidth>
        <DialogTitle>Archive Lead</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select a reason for archiving this lead.
          </DialogContentText>
          <FormControl sx={{ marginTop: '20px' }}>
            <RadioGroup
              name="archive-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            >
              {ARCHIVE_REASONS.map((archiveReason) => (
                <FormControlLabel
                  key={archiveReason}
                  value={archiveReason}
                  control={<Radio />}
                  label={archiveReason}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() =>
              setArchived(true, reason, 'Lead Archived - ' + reason)
            }
            disabled={!reason || isLoading}
            variant="contained"
            autoFocus
          >
            Archive
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default ArchiveLeadButton
